import { clients } from '@/services/client.factory'
import authstore from '@/store/modules/auth';

const cities = {
    namespaced: true,
    state: {
        city: [],
        counties: [],
        neighborhoods: []
    },
    getters: {
        city: (state) => state.city,
        counties: (state) => state.counties,
        neighborhoods: (state) => state.neighborhoods
    },
    mutations: {
        CITY_SET_ITEMS(state, city) {
            Object.assign(state, { city })
        },
        COUNTIES_SET_ITEMS(state, counties) {
            Object.assign(state, { counties })
        },
        NEIGHBORHOODS_SET_ITEMS(state, neighborhoods) {
            Object.assign(state, { neighborhoods })
        }
    },
    actions: {
        async getCityByCode({ commit }) {
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            await clients.placeServiceClient.getCityByCode(jwt.city_code)
                .then((res) => res.data)
                .then((data) =>
                    commit('CITY_SET_ITEMS', data)
                )
        },
        async getCountiesByCity({ commit }) {
            console.log("getcountiesss")
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            console.log(jwt.city_code)
            await clients.placeServiceClient.getCountiesByCity(jwt.city_code)
                .then((res) => res.data)
                .then((data) =>
                    commit('COUNTIES_SET_ITEMS', data)
                )
        },
        async getNeighborhoodsByCity({ commit }, {page, itemsPerPage, filter}) {
            console.log("getNeighborhoodsByCity")
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            filter.cityCode = jwt.city_code
            console.log("sadkjfhfkjflsaf",filter.cityCode)
            let body = {
                pageNumber:page,
                pagesize:itemsPerPage,
                searchCriteria:filter,
            }
            await clients.placeServiceClient.searchNeighborhoods(body)
                .then((res) => res.data)
                .then((data) =>
                    commit('NEIGHBORHOODS_SET_ITEMS', data)
                )
        },
        create(context) {
        },
        update(context) {
        },
        remove(context, item) {
        }
    }
}

export default cities;